import { JSX } from "solid-js"

export function IconCommandK(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 22 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.9"
        d="M2.70153 10.7287C2.30711 10.7287 1.94585 10.6326 1.61772 10.4403C1.2896 10.2448 1.02776 9.98295 0.832209 9.65483C0.639974 9.3267 0.543857 8.96544 0.543857 8.57102C0.543857 8.1733 0.639974 7.81037 0.832209 7.48224C1.02776 7.15412 1.2896 6.89228 1.61772 6.69673C1.94585 6.50118 2.30711 6.40341 2.70153 6.40341H3.85494V4.40483H2.70153C2.30711 4.40483 1.94585 4.30871 1.61772 4.11648C1.2896 3.92093 1.02776 3.66075 0.832209 3.33594C0.639974 3.00781 0.543857 2.64489 0.543857 2.24716C0.543857 1.84943 0.639974 1.48816 0.832209 1.16335C1.02776 0.835227 1.2896 0.575047 1.61772 0.382812C1.94585 0.187263 2.30711 0.089488 2.70153 0.089488C3.09925 0.089488 3.46218 0.187263 3.79031 0.382812C4.11843 0.575047 4.38027 0.835227 4.57582 1.16335C4.77137 1.48816 4.86914 1.84943 4.86914 2.24716V3.39062H6.86772V2.24716C6.86772 1.84943 6.96384 1.48816 7.15607 1.16335C7.35162 0.835227 7.6118 0.575047 7.93661 0.382812C8.26474 0.187263 8.62766 0.089488 9.02539 0.089488C9.42312 0.089488 9.78439 0.187263 10.1092 0.382812C10.4373 0.575047 10.6975 0.835227 10.8897 1.16335C11.0853 1.48816 11.1831 1.84943 11.1831 2.24716C11.1831 2.64489 11.0853 3.00781 10.8897 3.33594C10.6975 3.66075 10.4373 3.92093 10.1092 4.11648C9.78439 4.30871 9.42312 4.40483 9.02539 4.40483H7.88192V6.40341H9.02539C9.42312 6.40341 9.78439 6.50118 10.1092 6.69673C10.4373 6.89228 10.6975 7.15412 10.8897 7.48224C11.0853 7.81037 11.1831 8.1733 11.1831 8.57102C11.1831 8.96544 11.0853 9.3267 10.8897 9.65483C10.6975 9.98295 10.4373 10.2448 10.1092 10.4403C9.78439 10.6326 9.42312 10.7287 9.02539 10.7287C8.62766 10.7287 8.26474 10.6326 7.93661 10.4403C7.6118 10.2448 7.35162 9.98295 7.15607 9.65483C6.96384 9.3267 6.86772 8.96544 6.86772 8.57102V7.41761H4.86914V8.57102C4.86914 8.96544 4.77137 9.3267 4.57582 9.65483C4.38027 9.98295 4.11843 10.2448 3.79031 10.4403C3.46218 10.6326 3.09925 10.7287 2.70153 10.7287ZM2.70153 9.71449C2.91365 9.71449 3.10588 9.66312 3.27823 9.56037C3.45389 9.45762 3.5931 9.32008 3.69585 9.14773C3.80191 8.97206 3.85494 8.77983 3.85494 8.57102V7.41761H2.70153C2.49272 7.41761 2.30049 7.47064 2.12482 7.5767C1.95247 7.67945 1.81493 7.81866 1.71218 7.99432C1.60943 8.16667 1.55806 8.3589 1.55806 8.57102C1.55806 8.77983 1.60943 8.97206 1.71218 9.14773C1.81493 9.32008 1.95247 9.45762 2.12482 9.56037C2.30049 9.66312 2.49272 9.71449 2.70153 9.71449ZM2.70153 3.39062H3.85494V2.24716C3.85494 2.03504 3.80191 1.8428 3.69585 1.67045C3.5931 1.49811 3.45389 1.36056 3.27823 1.25781C3.10588 1.15507 2.91365 1.10369 2.70153 1.10369C2.49272 1.10369 2.30049 1.15507 2.12482 1.25781C1.95247 1.36056 1.81493 1.49811 1.71218 1.67045C1.60943 1.8428 1.55806 2.03504 1.55806 2.24716C1.55806 2.45928 1.60943 2.65317 1.71218 2.82883C1.81493 3.00118 1.95247 3.13873 2.12482 3.24148C2.30049 3.34091 2.49272 3.39062 2.70153 3.39062ZM7.88192 3.39062H9.02539C9.23751 3.39062 9.42975 3.34091 9.6021 3.24148C9.77444 3.13873 9.91199 3.00118 10.0147 2.82883C10.1175 2.65317 10.1689 2.45928 10.1689 2.24716C10.1689 2.03504 10.1175 1.8428 10.0147 1.67045C9.91199 1.49811 9.77444 1.36056 9.6021 1.25781C9.42975 1.15507 9.23751 1.10369 9.02539 1.10369C8.81327 1.10369 8.61938 1.15507 8.44372 1.25781C8.27137 1.36056 8.13382 1.49811 8.03107 1.67045C7.93164 1.8428 7.88192 2.03504 7.88192 2.24716V3.39062ZM9.02539 9.71449C9.23751 9.71449 9.42975 9.66312 9.6021 9.56037C9.77444 9.45762 9.91199 9.32008 10.0147 9.14773C10.1175 8.97206 10.1689 8.77983 10.1689 8.57102C10.1689 8.3589 10.1175 8.16667 10.0147 7.99432C9.91199 7.81866 9.77444 7.67945 9.6021 7.5767C9.42975 7.47064 9.23751 7.41761 9.02539 7.41761H7.88192V8.57102C7.88192 8.77983 7.93164 8.97206 8.03107 9.14773C8.13382 9.32008 8.27137 9.45762 8.44372 9.56037C8.61938 9.66312 8.81327 9.71449 9.02539 9.71449ZM4.86914 6.40341H6.86772V4.40483H4.86914V6.40341ZM14.1001 10.5V0.318182H15.3331V5.36932H15.4524L20.0263 0.318182H21.6371L17.3615 4.91193L21.6371 10.5H20.1456L16.6058 5.76705L15.3331 7.19886V10.5H14.1001Z"
        fill="#050012"
        fill-opacity="0.44"
      />
    </svg>
  )
}

export function IconInbox(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 11.75L17.6644 6.20056C17.4191 5.34195 16.6344 4.75 15.7414 4.75H8.2586C7.36564 4.75 6.58087 5.34196 6.33555 6.20056L4.75 11.75"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2142 12.3689C9.95611 12.0327 9.59467 11.75 9.17085 11.75H4.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V11.75H14.8291C14.4053 11.75 14.0439 12.0327 13.7858 12.3689C13.3745 12.9046 12.7276 13.25 12 13.25C11.2724 13.25 10.6255 12.9046 10.2142 12.3689Z"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconGrid(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V12M12 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V12M12 19.25V4.75M12 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V12M12 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V12M4.75 12H19.25"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconChevronDown(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 10.75L12 14.25L8.75 10.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconUsers(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M5.78168 19.25H13.2183C13.7828 19.25 14.227 18.7817 14.1145 18.2285C13.804 16.7012 12.7897 14 9.5 14C6.21031 14 5.19605 16.7012 4.88549 18.2285C4.773 18.7817 5.21718 19.25 5.78168 19.25Z"
      ></path>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M15.75 14C17.8288 14 18.6802 16.1479 19.0239 17.696C19.2095 18.532 18.5333 19.25 17.6769 19.25H16.75"
      ></path>
      <circle
        cx="9.5"
        cy="7.5"
        r="2.75"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      ></circle>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M14.75 10.25C16.2688 10.25 17.25 9.01878 17.25 7.5C17.25 5.98122 16.2688 4.75 14.75 4.75"
      ></path>
    </svg>
  )
}

export function IconLock(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M5.75 11.75C5.75 11.1977 6.19772 10.75 6.75 10.75H17.25C17.8023 10.75 18.25 11.1977 18.25 11.75V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.75Z"
      ></path>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M7.75 10.5V10.3427C7.75 8.78147 7.65607 7.04125 8.74646 5.9239C9.36829 5.2867 10.3745 4.75 12 4.75C13.6255 4.75 14.6317 5.2867 15.2535 5.9239C16.3439 7.04125 16.25 8.78147 16.25 10.3427V10.5"
      ></path>
    </svg>
  )
}

export function IconUnlock(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M5.75 11.75C5.75 11.1977 6.19772 10.75 6.75 10.75H17.25C17.8023 10.75 18.25 11.1977 18.25 11.75V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.75Z"
      ></path>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M7.75 10.5V9.84343C7.75 8.61493 7.70093 7.29883 8.42416 6.30578C8.99862 5.51699 10.0568 4.75 12 4.75C14 4.75 15.25 6.25 15.25 6.25"
      ></path>
    </svg>
  )
}
export function IconArrowLeft(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.25 6.75L4.75 12L10.25 17.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.25 12H5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconDotsHorizontal(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 11.75C7.5 12.1642 7.16421 12.5 6.75 12.5C6.33579 12.5 6 12.1642 6 11.75C6 11.3358 6.33579 11 6.75 11C7.16421 11 7.5 11.3358 7.5 11.75Z"
        fill="currentColor"
      />
      <path
        d="M13 11.75C13 12.1642 12.6642 12.5 12.25 12.5C11.8358 12.5 11.5 12.1642 11.5 11.75C11.5 11.3358 11.8358 11 12.25 11C12.6642 11 13 11.3358 13 11.75Z"
        fill="currentColor"
      />
      <path
        d="M18.5 11.75C18.5 12.1642 18.1642 12.5 17.75 12.5C17.3358 12.5 17 12.1642 17 11.75C17 11.3358 17.3358 11 17.75 11C18.1642 11 18.5 11.3358 18.5 11.75Z"
        fill="currentColor"
      />
      <path
        d="M7.5 11.75C7.5 12.1642 7.16421 12.5 6.75 12.5C6.33579 12.5 6 12.1642 6 11.75C6 11.3358 6.33579 11 6.75 11C7.16421 11 7.5 11.3358 7.5 11.75Z"
        stroke="currentColor"
      />
      <path
        d="M13 11.75C13 12.1642 12.6642 12.5 12.25 12.5C11.8358 12.5 11.5 12.1642 11.5 11.75C11.5 11.3358 11.8358 11 12.25 11C12.6642 11 13 11.3358 13 11.75Z"
        stroke="currentColor"
      />
      <path
        d="M18.5 11.75C18.5 12.1642 18.1642 12.5 17.75 12.5C17.3358 12.5 17 12.1642 17 11.75C17 11.3358 17.3358 11 17.75 11C18.1642 11 18.5 11.3358 18.5 11.75Z"
        stroke="currentColor"
      />
    </svg>
  )
}

export function IconDotsVertical(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 8C12.5 8.27614 12.2761 8.5 12 8.5C11.7239 8.5 11.5 8.27614 11.5 8C11.5 7.72386 11.7239 7.5 12 7.5C12.2761 7.5 12.5 7.72386 12.5 8Z"
        stroke="#86848D"
      />
      <path
        d="M12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12Z"
        stroke="#86848D"
      />
      <path
        d="M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z"
        stroke="#86848D"
      />
    </svg>
  )
}

export function IconSearch(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.0416 16.0418L12.9166 12.9168M3.95825 9.16683C3.95825 6.29035 6.2901 3.9585 9.16659 3.9585C12.0431 3.9585 14.3749 6.29035 14.3749 9.16683C14.3749 12.0433 12.0431 14.3752 9.16659 14.3752C6.2901 14.3752 3.95825 12.0433 3.95825 9.16683Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconMedical(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.75 8V5.75C9.75 5.19772 10.1977 4.75 10.75 4.75L13.25 4.75C13.8023 4.75 14.25 5.19772 14.25 5.75V8M15.25 13.5H12M12 13.5H8.75M12 13.5L12 10.75M12 13.5V16.25M17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25L4.75 10C4.75 8.89543 5.64543 8 6.75 8L17.25 8C18.3546 8 19.25 8.89543 19.25 10V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconPencil(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 19.25L9 18.25L18.9491 8.30083C19.3397 7.9103 19.3397 7.27714 18.9491 6.88661L17.1134 5.05083C16.7228 4.6603 16.0897 4.6603 15.6991 5.05083L5.75 15L4.75 19.25Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0234 7.03906L17.0234 10.0391"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconMaximize(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 14.75V19.25H9.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.25 9.25V4.75H14.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 19L10.25 13.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 5L13.75 10.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconMinimize(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M10.25 18.25V13.75H5.75"
        stroke="#824E00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.75 5.75V10.25H18.25"
        stroke="#824E00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.75 19.25L10.25 13.75"
        stroke="#824E00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.25 4.75L13.75 10.25"
        stroke="#824E00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export function IconUserCircle(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 12.5C19.25 16.5041 16.0041 19.75 12 19.75C7.99594 19.75 4.75 16.5041 4.75 12.5C4.75 8.49594 7.99594 5.25 12 5.25C16.0041 5.25 19.25 8.49594 19.25 12.5Z"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 10.5C14.25 11.7426 13.2426 12.75 12 12.75C10.7574 12.75 9.75 11.7426 9.75 10.5C9.75 9.25736 10.7574 8.25 12 8.25C13.2426 8.25 14.25 9.25736 14.25 10.5Z"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.19727 17.5C8.34373 16.125 10.0696 15.25 11.9998 15.25C13.93 15.25 15.6559 16.125 16.8024 17.5"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconCalendarTimer(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 9.75V9.25C19.25 8.14543 18.3546 7.25 17.25 7.25H6.75C5.64543 7.25 4.75 8.14543 4.75 9.25V17.75C4.75 18.8546 5.64543 19.75 6.75 19.75H9.25M8 5.25V8.75M16 5.25V8.75"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 14.25V15.5L16.25 16.75M15 19.75C12.6528 19.75 10.75 17.8472 10.75 15.5C10.75 13.1528 12.6528 11.25 15 11.25C17.3472 11.25 19.25 13.1528 19.25 15.5C19.25 17.8472 17.3472 19.75 15 19.75Z"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconCloseCircle(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.75 9.75L14.25 14.25"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 9.75L9.75 14.25"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconCalendarPlus(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 11.25V8.75C19.25 7.64543 18.3546 6.75 17.25 6.75H6.75C5.64543 6.75 4.75 7.64543 4.75 8.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H11.25M17 14.75V19.25M19.25 17H14.75M8 4.75V8.25M16 4.75V8.25M7.75 10.75H16.25"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconNoAvatar(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.39786 9C4.98178 9.91422 4.75 10.93 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C13.07 19.25 14.0858 19.0182 15 18.6021M17.3625 16.8792C18.5351 15.5912 19.25 13.8791 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75C10.1054 4.75 8.38052 5.47674 7.08894 6.66666M9.87283 9.26488C10.1775 8.38322 11.0148 7.75 12 7.75C13.2426 7.75 14.25 8.75736 14.25 10C14.25 10.9767 13.6277 11.808 12.7579 12.1191M7.19745 17C8.14174 15.8675 9.47909 15.0742 10.9999 14.8296L11.2499 14.8008M4.75 4.75L19.25 19.25"
        stroke="#86848D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function IconClock(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
        stroke="#1A1523"
        stroke-width="1.5"
      />
      <path
        d="M12 8V12L14 14"
        stroke="#1A1523"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  )
}

export function IconPhone(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.89286 4.75H6.06818C5.34017 4.75 4.75 5.34017 4.75 6.06818C4.75 13.3483 10.6517 19.25 17.9318 19.25C18.6598 19.25 19.25 18.6598 19.25 17.9318V15.1071L16.1429 13.0357L14.5317 14.6468C14.2519 14.9267 13.8337 15.0137 13.4821 14.8321C12.8858 14.524 11.9181 13.9452 10.9643 13.0357C9.98768 12.1045 9.41548 11.1011 9.12829 10.494C8.96734 10.1537 9.06052 9.76091 9.32669 9.49474L10.9643 7.85714L8.89286 4.75Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export function IconUpload(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.25 14.75V16.25C5.25 17.9069 6.59315 19.25 8.25 19.25H16.75C18.4069 19.25 19.75 17.9069 19.75 16.25V14.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 14.25L12.5 5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.25 8.25L12.5 4.75L15.75 8.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
